import { matchPath } from 'react-router-dom';
import { PUBLIC_PATHS } from 'routes/routesRegistry';

export { PUBLIC_PATHS };

export const isPublicPath = (pathname: string): boolean =>
  PUBLIC_PATHS.some(p => matchPath({ path: p, end: false }, pathname) !== null);
